module.exports = __webpack_public_path__ + "63710a994ce9f3238dabd05d7bc65517.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-28.png
// module id = 1540
// module chunks = 0